/*
 * @Author: 褚天豪
 * @Date: 2025-09-30 11:12:39
 * @LastEditors: HGcth66 HGcth66@163.com
 * @LastEditTime: 2025-09-30 11:18:04
 * @FilePath: \emercontrol_php\front\src\mixins\websocketResponseMixin.js
 * @Description: 
 * 
 * Copyright (c) 2025 by ${git_name_email}, All Rights Reserved. 
 */
/**
 * WebSocket数据反馈Mixin
 * 提供通用的数据加载完成后的反馈机制
 */
export const websocketResponseMixin = {
  methods: {
    /**
     * 发送数据反馈给后端
     * @param {Object} responseData - 要发送的数据对象
     */
    sendAgentResponse(responseData) {
      // 等待DOM更新完成
      this.$nextTick(() => {
        // 短暂延迟确保数据完全加载
        setTimeout(() => {
          if (window.sendAgentResponse) {
            window.sendAgentResponse(responseData);
          } else {
            console.warn('sendAgentResponse方法未找到，请确保websocket已正确初始化');
          }
        }, 500);
      });
    },

    /**
     * 页面数据加载完成后的通用处理方法
     * 子组件需要重写此方法来定义具体的数据收集逻辑
     */
    onDataLoaded() {
      // 子组件重写此方法来发送特定的数据
      console.log('页面数据加载完成，可以在此发送数据反馈');
    },

    /**
     * 延迟执行数据反馈（适用于异步数据加载场景）
     * @param {Function} dataCollector - 数据收集函数，返回要发送的数据对象
     * @param {Number} delay - 延迟时间（毫秒），默认1000ms
     */
    sendResponseAfterDelay(dataCollector, delay = 1000) {
      this.$nextTick(() => {
        setTimeout(() => {
          const responseData = typeof dataCollector === 'function' ? dataCollector() : dataCollector;
          this.sendAgentResponse(responseData);
        }, delay);
      });
    }
  }
};

export default websocketResponseMixin;
